import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/gossip';

export default function RecommendedSection() {
  const items = articles.slice(4, 10);

  return (
    <section className="mx-auto max-w-[1240px] px-4 py-16 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="热门推荐"
        title="这几天被反复点开的内容"
        description="从生图细节到造型逻辑，挑的都是经得起放大的画面。"
        action={
          <Link
            to="/category/all"
            className="flex h-10 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-4 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
          >
            更多图集
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        }
      />

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}